import React, { useState, useMemo } from "react";
import { LoginV1 } from "./LoginV1";
import { LoginV2 } from "./LoginV2";

export const LoginPage: React.FC = () => {
  const [guardVersion] = useState(window.__guardVersion__);

  const renderLoginPage = useMemo(() => {
    switch (guardVersion) {
      case "v1":
        return <LoginV1 />;

      case "v2":
        return <LoginV2 />;
      // 默认值
      default:
        return <LoginV1 />;
    }
  }, [guardVersion]);

  return renderLoginPage;
};
